import { datesToISO } from "@";

// Payload for search values
export const searchValuesPayload = ({
  page,
  user,
  toDate,
  pageSize,
  activity,
  fromDate,
  action,
}) => ({
  page,
  userId: user,
  pageSize: pageSize,
  action: parseInt(action),
  toDate: datesToISO(toDate),
  activity: parseInt(activity),
  fromDate: datesToISO(fromDate),
});
